import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {DepartmentModel} from '../../../models/department.model';
import {AlertService} from '../../../services/notify/alert.service';
import {DepartmentControlService} from '../../../services/departments/department-control.service';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {ModalService} from '../../../services/modal/modal.service';
import {MemberModel} from '../../../models/user.model';
import {MemberService} from '../../../services/member.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-departments-control-list',
    templateUrl: './departments-control-list.component.html',
    styleUrls: ['./departments-control-list.component.scss'],
})
export class DepartmentsControlListComponent implements OnInit {
    @ViewChild('collectionView') public collectionView: ElementRef;
    public departmentsList: DepartmentModel[] = [];
    public loading = false;

    public currentMember: MemberModel;

    isLockButton = false;
    isLockGroupButton = [];

    constructor(
        protected alertService: AlertService,
        protected departmentControl: DepartmentControlService,
        public modalService: ModalService,
        protected memberService: MemberService,
        protected translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        void this.getDepartments(true);
        this.memberService.getCurrentMember().then(res => {
            this.currentMember = res;
        });
    }

    async getDepartments(forced = false): Promise<any> {
        this.loading = true;
        this.departmentsList = [];
        const result = await this.departmentControl.getDepartmentList(forced);
        this.loading = false;
        if (result) {
            this.departmentsList = result as DepartmentModel[];
        }
    }

    async deleteDepartment(department: DepartmentModel): Promise<any> {
        this.isLockGroupButton[this.departmentsList.indexOf(department)] = true;
        this.departmentControl.deleteDepartment(department.id).then(() => {
            this.isLockGroupButton[this.departmentsList.indexOf(department)] = false;
            this.getDepartments(true);
        });
    }

    async createDepartment(depName: string, modal: NgbModalRef): Promise<any> {
        const name = {
            name: depName,
        };
        if (!depName) {
            this.alertService.setAlert(this.translate.instant('ALERTS.SET_NAME'), 'blue');
            return;
        }
        this.isLockButton = true;
        this.departmentControl.createDepartment(name).then(() => {
            modal.close();
            this.getDepartments(true);
            this.isLockButton = false;
        });
    }
}
